const tables = [
  {
    name: "Number",
  },
  {
    name: "Date",
  },
  {
    name: "Category",
  },
  {
    name: "Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
